module.exports = __webpack_public_path__ + "static/media/29BDOS4.6b043a2a.jpg";